<!--我的订单-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">商城订单</div>
    <search :data="search.list" @click="updateConditions"></search>
    <el-table
      :data="table.list"
      style="width: 100%">
      <template slot="empty">
        <no-data></no-data>
      </template>

      <el-table-column
        prop="orderCode"
        label="订单号">
        <template slot-scope="scope">
          <a href="javascript:;" @click="searchCriteria(scope.row.orderCode, index=1)">{{scope.row.orderCode}}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodTitle"
        label="商品名 ">
      </el-table-column>
      <el-table-column
        label="市场价">
        <template slot-scope="scope">
          {{scope.row.goodMinMarketPrice}}~{{scope.row.goodMaxMarketPrice}}
        </template>
      </el-table-column>
      <el-table-column
        prop="goodScore"
        label="售价">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="数量">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === -1">交易取消</span>
          <span v-if="scope.row.status === 1">待发货</span>
          <span v-if="scope.row.status === 2">待收货</span>
          <span v-if="scope.row.status === 3">交易成功</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="publishTime"
        label="订单时间">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showOrder(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="table.pagination.page"
      :total="table.pagination.totalRow"
      :page-size="table.pagination.pageSize"
      :page-sizes="table.pagination.pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
  import ResponseParse from '@/utils/response-parse'
  import Search from '@/components/common/Search.vue'
  import { SEARCH_CONDITION } from '@/models/client/my-order'
  import Api from '@/api/client/my-order'

  export default {
    created () {
      this.search.list = SEARCH_CONDITION
      this.table.loading = true
      this.requestList()
    },
    components: {
      Search
    },
    data () {
      return {
        search: {
          list: [],
          condition: {}
        },
        table: {
          loading: true,
          list: [],
          pagination: {}
        }
      }
    },
    methods: {
      requestList () {
        this.table.list = []
        let search = Object.assign({}, this.search.condition, this.table.pagination)
        Api.list({search: search}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.table.list = body
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.table.list = []
          }
          this.table.loading = false
        })
      },
      searchCriteria (val, index) {
        this.$set(this.search.list[index], 'value', val)
      },
      handleDelete (index, rows) {
        rows.splice(index, 1)
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        const date = conditions.date || []
        this.search.condition = Object.assign({}, conditions, {startTime: date[0], endTime: date[1]})
        this.requestList()
      },
      showOrder (id) {
        this.$router.push({name: 'order-details', params: {id: id}})
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/client/MyOrder.vue